import { Component, OnInit, ChangeDetectorRef, ViewChildren, ElementRef } from '@angular/core';
import { Inspection, InspectionPlugin, Resource } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';
import * as _ from 'lodash';
import { FilesAndSuggestionsPluginService } from './filesandsuggestions-plugin.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { ResourceType } from '../../utils';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    templateUrl: './filesandsuggestions.component.html',
    standalone: false
})
export class FilesAndSuggestionsPluginComponent extends BasePlugin implements OnInit {
  @ViewChildren('image')
  images: ElementRef[];
  public plugin: any;
  public assets: any = [];
  public inspection: Inspection;
  public assetUrls: any = {};

  constructor(
    private cdRef: ChangeDetectorRef,
    private service: FilesAndSuggestionsPluginService,
    private indexedDb: IndexedDbService,
    private sanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.service.getEditedImagesIds().subscribe((ids) => {
      ids.forEach((id) => {
        const img = this.images.find((i) => i.nativeElement.src.includes(id));
        if (img) {
          img.nativeElement.src = `${img.nativeElement.src}?v=${Date.now()}`;
        }
      });
    });
  }

  public getImageUrl(assetId: string) {
    if (this.inspection.isOffline && !this.isManager) {
      return this.assetUrls[assetId];
    } else {
      return `/api/assets/${assetId}/content`;
    }
  }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);

    for (let i = 0; i < this.plugin.config.Assets.length; i++) {
      const assetId = this.plugin.config.Assets[i];
      const asset = {
        id: assetId,
        comment: this.plugin.config.Comments ? this.plugin.config.Comments[assetId] : '',
        suggestedAsset: this.plugin.config.Sugestions ? this.plugin.config.Sugestions[assetId] : null,
        annotationComments: this.plugin.config.AnnotationsComments
          ? this.plugin.config.AnnotationsComments[assetId]
          : null,
        svg: this.plugin.config.Svgs ? this.plugin.config.Svgs[assetId] : '',
        type: this.plugin.config.Types ? this.plugin.config.Types[assetId] : -1
      };
      this.assets.push(asset);
      if (this.inspection.isOffline) {
        this.indexedDb.getImageUrl(`${asset.id}`).subscribe((url) => {
          this.assetUrls[asset.id] = url;
        });
      }
    }
    this.cdRef.detectChanges();
  }

  getSvg(svg, assetId) {
    if (svg) {
      let assetUrl = this.getImageUrl(assetId);
      if (assetUrl?.changingThisBreaksApplicationSecurity) {
        assetUrl = assetUrl.changingThisBreaksApplicationSecurity;
      }
      let svgToRender = svg.replace(/ns\d+:href=""/gi, `href="${assetUrl}"`);
      const htmlData = this.sanitizer.bypassSecurityTrustHtml(svgToRender);
      return htmlData;
    }
  }

  getEditAssetRoute(asset: any) {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.plugin.inspectionId,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'fileandsuggestion',
      asset.id,
      'edit'
    ];
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'filesandsuggestions',
      'add'
    ];
  }

  getSuggestionEditRoute(asset: any) {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.plugin.inspectionId,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'fileandsuggestion',
      asset.id,
      'editsuggestion'
    ];
  }
}

PluginComponent.plugins['filesandsuggestions'] = FilesAndSuggestionsPluginComponent;

PluginComponent.downloads['filesandsuggestions'] = (plugin: InspectionPlugin) => {
  const resources: Resource[] = [];
  if (plugin.config != null && plugin.config.Assets != null) {
    _.each(plugin.config.Assets, (asset) => {
      resources.push(
        new Resource(ResourceType.Asset, asset, {
          url: `/assets/${asset}/content`
        })
      );
    });
  }
  return resources;
};
